import script from "./SkeletonChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonChart.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonChart.vue?vue&type=style&index=0&id=1d9573aa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d9573aa"]])

export default __exports__